// src/config.js
const BASE_URL = "https://ai-chatbot-builder-backend-g298.onrender.com";

// const BASE_URL = "http://localhost:5000";


export default BASE_URL;
